var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.imgUrl}}),_c('p',[_vm._v("感谢您对我们工作的支持！")]),_c('p',[_vm._v("您已成功的更新了相应信息！")])])}
var staticRenderFns = []

export { render, staticRenderFns }